import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import {
  createOrganization,
  updateOrganization,
  getAllCorporationIds,
  getOrgUser,
  getSingleOrganization,
  getZipCode,
} from "../Api/ApiCalls";
import LoadingSpinner from "../common/Loading";
import { organizationValidationSchema } from "../common/Validation";
import log from "../core/log";
import { useLocation } from "react-router-dom";
import { useTable, usePagination } from "react-table";

export const CreateOrganization = () => {
  const formOptions = { resolver: yupResolver(organizationValidationSchema) };
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [corporation, setCorporation] = useState([]);
  const [organizationData, setOrganizationData] = useState();
  const [toasting, setToasting] = useState(false);
  const location = useLocation();
  const { id, corp_code } = location.state || "";

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
  } = useForm(formOptions);

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "user_name",
      },
      {
        Header: "Email Address",
        accessor: "email_address",
      },
      {
        Header: "Phone Number",
        accessor: "phone_number",
      },
      {
        Header: "Status",
        accessor: "status",
      },
    ],
    []
  );
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    previousPage,
    nextPage,
    canPreviousPage,
    canNextPage,
    prepareRow,
    pageOptions,
    state,
    setPageSize,
    pageSize,
  } = useTable({ columns, data: users }, usePagination);
  const { pageIndex } = state;

  const onSubmit = async (data) => {
    setLoading(true);
    if (!organizationData) {
      try {
        const result = await createOrganization(data);
        if (result.status) {
          toast.success("Organization created successfully");
          resetFields(data);
        } else {
          toast.info("Organization code exist");
          reset({ ...data, organization_code: "" });
        }
        setLoading(false);
      } catch (err) {
        console.log(err);
        log("Error while creating organization data ", err);
        setLoading(false);
      }
    } else {
      try {
        delete data.id;

        await updateOrganization({
          id: organizationData.id,
          payload: data,
        });

        toast.success("Organization Updated successfully", {
          toastId: "update",
          onClose: () => {
            setToasting(false);
          },
          onOpen: () => {
            setToasting(true);
          },
        });
        reset(data);

        setLoading(false);
      } catch (err) {
        console.log(err);
        log("Error while updating organization data ", err);
        setLoading(false);
      }
    }
  };

  const resetFields = (data) => {
    if (!data) return;
    const tempObj = {};
    Object.keys(data).forEach((field) => {
      tempObj[field] = "";
    });
    reset(tempObj);
  };

  const getCorporationIds = async () => {
    try {
      setLoading(true);
      const data = await getAllCorporationIds();
      if (data) {
        setCorporation(data);
      }
      setLoading(false);
    } catch (err) {
      log(`Error while fetching organizations: `, err);
      setLoading(false);
    }
  };

  const getOrganizationUser = async (corporation_code, organization_code) => {
    try {
      setLoading(true);
      const data = await getOrgUser(corporation_code, organization_code);
      if (data.status) {
        setUsers(data.data);
      }
      setLoading(false);
    } catch (err) {
      log(`Error while fetching organizations: `, err);
      setLoading(false);
    }
  };
  const getOrganizationData = async () => {
    setLoading(true);
    try {
      const result = await getSingleOrganization(id, corp_code);
      if (result.status) {
        setOrganizationData(result.data);
        getOrganizationUser(result.data.corporation_code, result.data.id);
        reset(result.data);
      } else {
        toast.info(result.message);
      }
      setLoading(false);
    } catch (err) {
      console.log(err);
      log("Error while fetching organization data ", err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getOrganizationData();
    } else {
      resetFields(organizationData);
      setOrganizationData();
      setUsers([]);
      getCorporationIds();
    }

    setPageSize(10);
  }, [location]);
  const handleOnBlurZipCode = async (e) => {
    setLoading(true);
    try {
      const { value } = e.target;
      if (value) {
        const response = await getZipCode(value);
        if (response && response.status) {
          setValue("state", response.data.state);
          setValue("city", response.data.city);
        } else {
          toast.error("Please enter a valid zip code");
          setValue("state", "");
          setValue("city", "");
          setValue("pincode", "");
        }
      } else {
        setValue("state", "");
        setValue("city", "");
      }

      setLoading(false);
    } catch (err) {
      console.log("Error while validating zip code", err);
      setValue("state", "");
      setValue("pincode", "");
      setValue("city", "");
      setLoading(false);
      toast.error("Something went wrong . Please try again later.");
    }
  };
  return (
    <>
      <div className="grid grid-rows-1">
        <div className="flex overnpmflow-hidden">
          <div className="content relative flex-1 pb-2">
            <form onSubmit={handleSubmit(onSubmit)}>
              <h2 className="text-4xl text-[#96BF61] font-bold">
                {id ? "Edit Organization" : "Create Organization"}
              </h2>
              {loading && <LoadingSpinner />}
              <div className="grid grid-cols-12 mt-3">
                <div className="col-span-12 lg:col-span-12">
                  <div className=" shadow-md rounded">
                    <div className="bg-white rounded-[21px] p-10 mt-6">
                      <div className=" overflow-y-scroll">
                        <div className="mt-5 flex flex-col sm:flex-row items-center">
                          <div className="flex-auto w-1/3 relative">
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.corporation_code?.message}
                            </span>
                            <label
                              htmlFor="corporation_code"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Corporation code
                              <span className="text-red-600">*</span>
                            </label>
                            {!id ? (
                              <>
                                <select
                                  {...register("corporation_code")}
                                  className="py-3 shadow-md w-full block px-4 mt-0 bg-white border border-b-2 z-1 focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md "
                                >
                                  <option value={""}>Select a code</option>
                                  {corporation &&
                                    corporation.length &&
                                    corporation.map((val, index) => {
                                      return (
                                        <option key={index} value={val.id}>
                                          {val.id}
                                        </option>
                                      );
                                    })}
                                </select>
                                <div className="absolute right-[7px] top-[52px] pointer-events-none">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                                      fill="#1D192B"
                                    ></path>
                                  </svg>
                                </div>
                              </>
                            ) : (
                              <input
                                id="corporation_code"
                                className={`py-3 block shadow-md w-full px-4 mt-0  ${
                                  id ? "bg-gray-300" : "bg-white"
                                } border border-b-2 appearance-none w-full focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md`}
                                disabled={id}
                                value={corp_code}
                                placeholder="Corporation code"
                              />
                            )}
                          </div>

                          <div className="flex-auto mx-8 w-1/3 relative">
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.organization_name?.message}
                            </span>
                            <label
                              htmlFor="organization_name"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Organization name
                              <span className="text-red-600">*</span>
                            </label>
                            <input
                              id="organization_name"
                              type="text"
                              {...register("organization_name", {
                                required: true,
                              })}
                              className="py-3 bg-white shadow-md block w-full px-4 mt-0 bg-transparent border border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md"
                              placeholder="Organization name"
                            />
                          </div>

                          <div className="flex-auto w-1/3 c-select relative">
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.organization_code?.message}
                            </span>
                            <label
                              htmlFor="organization_code"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Organization code
                              <span className="text-red-600">*</span>
                            </label>
                            <input
                              id="organization_code"
                              {...register("organization_code", {
                                required: true,
                              })}
                              className={`py-3 block shadow-md w-full px-4 mt-0  ${
                                organizationData ? "bg-gray-300" : "bg-white"
                              } border border-b-2 appearance-none w-full focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md`}
                              disabled={organizationData}
                              placeholder="Organization code"
                            />
                          </div>
                        </div>
                        <div className="mt-5 flex flex-col sm:flex-row items-center">
                          <div className="flex-auto w-1/3 relative">
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.country?.message}
                            </span>
                            <label
                              htmlFor="language"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Country
                              <span className="text-red-600">*</span>
                            </label>
                            <Controller
                              name={"country"}
                              control={control}
                              render={({ field: { onChange, value } }) => {
                                return (
                                  <>
                                    <select
                                      onChange={(e) => {
                                        onChange(e);
                                      }}
                                      id="country"
                                      value={value}
                                      label="Select country"
                                      variant="outlined"
                                      className={`py-3 shadow-md w-full block px-4 mt-0 bg-white border border-b-2 z-1 focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md ${
                                        value ? " focus-label" : ""
                                      }`}
                                    >
                                      <option value="">Select a country</option>
                                      <option value="usa">USA</option>
                                    </select>
                                    <div className="absolute right-2 top-[52px] pointer-events-none">
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                                          fill="#1D192B"
                                        ></path>
                                      </svg>
                                    </div>
                                  </>
                                );
                              }}
                              rules={{
                                required: {
                                  value: true,
                                  message: "Please select a country",
                                },
                              }}
                            />
                          </div>
                          <div className="flex-auto mx-8 w-1/3 relative">
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.pincode?.message}
                            </span>
                            <label
                              htmlFor="pincode"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Zip Code
                              <span className="text-red-600">*</span>
                            </label>
                            <input
                              id="pincode"
                              type="text"
                              {...register("pincode", {
                                required: true,
                                onBlur: (e) => {
                                  handleOnBlurZipCode(e);
                                },
                              })}
                              onKeyDown={(e) => {
                                e.keyCode === 13 && e.target.blur();
                              }}
                              className="py-3 bg-white shadow-md block w-full px-4 mt-0 bg-transparent border border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md"
                              placeholder="Zip Code"
                            />
                          </div>
                          <div className="flex-auto  w-1/3 relative">
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.state?.message}
                            </span>
                            <label
                              htmlFor="language"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              State
                              <span className="text-red-600">*</span>
                            </label>
                            <input
                              id="state"
                              type="text"
                              {...register("state")}
                              className="pt-6 pb-1 bg-gray-300 shadow-md block w-full px-4 mt-0 border border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md"
                              placeholder=" "
                              disabled
                            />
                          </div>
                        </div>
                        <div className="mt-5 flex flex-col sm:flex-row items-center">
                          <div className="flex-auto w-1/3 relative">
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.city?.message}
                            </span>
                            <label
                              htmlFor="language"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              City
                              <span className="text-red-600">*</span>
                            </label>
                            <input
                              id="city"
                              type="text"
                              {...register("city")}
                              className="pt-6 pb-1 bg-gray-300 shadow-md block w-full px-4 mt-0 border border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md"
                              placeholder=" "
                              disabled
                            />
                          </div>
                          <div className="flex-auto mx-8 w-1/3 relative">
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.address_line_one?.message}
                            </span>
                            <label
                              htmlFor="address_line_one"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Address Line 1
                              <span className="text-red-600">*</span>
                            </label>
                            <input
                              id="address_line_one"
                              type="text"
                              placeholder="Address Line 1"
                              className="py-3 shadow-md bg-white block w-full px-4 mt-0 bg-transparent border border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md"
                              {...register("address_line_one")}
                            />
                          </div>
                          <div className="flex-auto w-1/3  relative">
                            <label
                              htmlFor="address_line_two"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Address Line 2
                            </label>
                            <input
                              id="address_line_two"
                              type="text"
                              placeholder="Address Line 2"
                              className="py-3 shadow-md bg-white block w-full px-4 mt-0 bg-transparent border border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md"
                              {...register("address_line_two")}
                            />
                          </div>
                        </div>

                        <div className="mt-5 flex flex-col sm:flex-row items-center">
                          <div className="flex-auto w-1/3 relative">
                            <label
                              htmlFor="address_line_three"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Address Line 3
                            </label>
                            <input
                              id="address_line_three"
                              type="text"
                              placeholder="Address Line 3"
                              className="py-3 shadow-md bg-white block w-full px-4 mt-0 bg-transparent border border-b-2 appearance-none focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md"
                              {...register("address_line_three")}
                            />
                          </div>
                          <div className="flex-auto mx-8 w-1/3 relative">
                            <span className="text-red-600 top-0 absolute my-4 block">
                              {errors?.organization_status?.message}
                            </span>
                            <label
                              htmlFor="language"
                              className="text-black font-semibold text-sm mb-4 block"
                            >
                              Status
                              <span className="text-red-600">*</span>
                            </label>
                            <Controller
                              name={"organization_status"}
                              control={control}
                              render={({ field: { onChange, value } }) => {
                                return (
                                  <>
                                    <select
                                      onChange={(e) => {
                                        onChange(e);
                                      }}
                                      id="organization_status"
                                      value={value}
                                      label="Select Status"
                                      variant="outlined"
                                      className={`py-3 shadow-md block w-full bg-white px-4 mt-0 bg-transparent border border-b-2  z-1 focus:outline-none focus:ring-0 focus:border-gray-400 border-gray-200 rounded-md ${
                                        value ? " focus-label" : ""
                                      }`}
                                    >
                                      <option value={""}>
                                        Select a status
                                      </option>
                                      <option value={"active"}>Active</option>
                                      <option value={"inactive"}>
                                        Inactive
                                      </option>
                                    </select>
                                    <div className="absolute right-2 top-[52px] pointer-events-none">
                                      <svg
                                        width="20"
                                        height="20"
                                        viewBox="0 0 24 24"
                                      >
                                        <path
                                          d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                                          fill="#1D192B"
                                        ></path>
                                      </svg>
                                    </div>
                                  </>
                                );
                              }}
                              rules={{
                                required: {
                                  value: true,
                                  message: "Please select a status",
                                },
                              }}
                            />
                          </div>
                          <div className="flex-auto w-1/3 relative"></div>
                        </div>
                        {users && users.length !== 0 && (
                          <>
                            <h2 className="mt-10 text-xl text-[#96BF61] font-bold mb-6">
                              Available Users in the Organization
                            </h2>
                            <div className="overflow-y-scroll flex justify-center rounded-[21px] rounded-bl-none rounded-br-none ">
                              <table
                                id="table"
                                {...getTableProps()}
                                className="rounded-[21px] rounded-bl-none rounded-br-none w-full"
                              >
                                <thead className="border bg-white">
                                  {headerGroups.map((headerGroup) => (
                                    <tr
                                      className="rounded-md"
                                      {...headerGroup.getHeaderGroupProps()}
                                    >
                                      {headerGroup.headers.map((column) => (
                                        <th
                                          data-type="number"
                                          scope="col"
                                          className="font-medium bg-[#024C85] border border-r-0 border-l-0 text-left text-white px-10 py-6"
                                          {...column.getHeaderProps()}
                                        >
                                          {column.render("Header")}
                                        </th>
                                      ))}
                                      <th
                                        scope="col"
                                        className="font-medium border bg-[#024C85] border-r-0 border-l-0 text-left text-white px-10 py-4"
                                      >
                                        Actions
                                      </th>
                                    </tr>
                                  ))}
                                </thead>

                                <tbody {...getTableBodyProps()}>
                                  {page.map((row) => {
                                    prepareRow(row);
                                    return (
                                      <tr
                                        className="bg-white border border-r-0 border-l-0 transition duration-300 ease-in-out hover:bg-gray-100"
                                        {...row.getRowProps()}
                                      >
                                        {row.cells.map((cell) => (
                                          <td
                                            className="text-gray-900 border border-r-0 border-l-0 font-light px-8 py-2 whitespace-nowrap"
                                            {...cell.getCellProps()}
                                          >
                                            {" "}
                                            {cell.render("Cell")}{" "}
                                          </td>
                                        ))}
                                        <td className="text-gray-900 border border-r-0 border-l-0 font-light px-8 py-2 whitespace-nowrap">
                                          <div className="flex justify-start">
                                            <NavLink
                                              to="/edit/user"
                                              state={{
                                                id: row?.original?.id,
                                                corp_code:
                                                  row?.original
                                                    ?.corporation_code,
                                                org_code:
                                                  row?.original
                                                    ?.organization_code,
                                              }}
                                              className="border p-3"
                                            >
                                              <span className="bg-edit block cursor-pointer"></span>
                                            </NavLink>
                                          </div>
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </div>
                            <div className="mt-6 flex justify-end items-center">
                              <div className="mr-4">
                                <span className="text-[#121212]">
                                  Items per page
                                </span>
                              </div>
                              <div className="relative mr-4">
                                <select
                                  value={pageSize}
                                  onChange={(e) =>
                                    setPageSize(Number(e.target.value))
                                  }
                                  className="pl-6 pr-9 border border-[#024C85] rounded-md outline-none bg-[#EDF9FF] font-bold text-[#024C85]"
                                >
                                  {[10, 20].map((pageSize) => (
                                    <option key={pageSize} value={pageSize}>
                                      {pageSize}
                                    </option>
                                  ))}
                                </select>
                                <div className="absolute right-[7px] top-[16px] pointer-events-none">
                                  <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                  >
                                    <path
                                      d="M12 17.414 3.293 8.707l1.414-1.414L12 14.586l7.293-7.293 1.414 1.414L12 17.414z"
                                      fill="#1D192B"
                                    ></path>
                                  </svg>
                                </div>
                              </div>
                              <div className="flex items-center">
                                <span className="mr-4">
                                  Page {pageIndex + 1} of {pageOptions.length}
                                </span>
                                <div
                                  className={`${
                                    !canPreviousPage
                                      ? "bg-[#EDF9FF]"
                                      : "bg-tranparent"
                                  } px-[22px] py-[10px] rounded-[4px] mr-4 cursor-pointer border border-[#024C85] text-[#024C85] font-bold`}
                                  onClick={() => previousPage()}
                                  disabled={!canPreviousPage}
                                >
                                  <svg
                                    width="8"
                                    height="10"
                                    viewBox="0 0 8 10"
                                    fill="none"
                                  >
                                    <path
                                      d="M7.08748 1.175L5.91248 0L0.912476 5L5.91248 10L7.08748 8.825L3.27081 5L7.08748 1.175Z"
                                      fill="#024C85"
                                    />
                                  </svg>
                                </div>
                                <div
                                  className={`${
                                    !canNextPage
                                      ? "bg-[#EDF9FF]"
                                      : "bg-tranparent"
                                  } px-[22px] rounded-[4px] py-[10px] cursor-pointer border border-[#024C85] text-[#024C85] font-bold`}
                                  onClick={() => nextPage()}
                                  disabled={!canNextPage}
                                >
                                  <svg
                                    width="8"
                                    height="10"
                                    viewBox="0 0 8 10"
                                    fill="none"
                                  >
                                    <path
                                      d="M2.08748 0L0.912476 1.175L4.72914 5L0.912476 8.825L2.08748 10L7.08748 5L2.08748 0Z"
                                      fill="#024C85"
                                    />
                                  </svg>
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                        <div className="mt-8 text-right">
                          <button
                            type="form"
                            disabled={toasting}
                            className="px-4 py-2 text-lg text-white transition-all duration-150 ease-linear rounded-md shadow outline-none font-semibold bg-[#024C85] hover:bg-[#134d86] hover:shadow-lg focus:outline-none"
                          >
                            {organizationData
                              ? "Update Organisation"
                              : "Create Organisation"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
